import type { z } from 'zod'
import type { AnyValue, ZodSimplify } from './utility-types.ts'

export const satisfiesSchema = <Schema extends z.ZodTypeAny>(
  schema: Schema,
  input: AnyValue
): input is ZodSimplify<Schema> => schema.safeParse(input).success
